module.exports = __webpack_public_path__ + "img/icon-delete.07c02c83.svg";